module.exports = __webpack_public_path__ + "static/media/Vector.d24cfe39.png";